import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DotLottieVue } from '@lottiefiles/dotlottie-vue'

export default /*@__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DotLottieVue), {
    class: "w-96 h-96",
    autoplay: "",
    loop: "",
    src: "https://lottie.host/015ad31a-47b9-4b8c-9cee-36f722436662/VuAQ8TMMp3.lottie"
  }))
}
}

})